import React from 'react';

export default function Loader(props) {
    const {
        show
    } = props

    if (show)
        return (
            <div
                style={{
                    position: 'fixed',
                    backgroundColor: "#00000090",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100vw',
                    top: 0,
                    left: 0
                }}
            >
                <div class="spinner-border text-light" role="status">
                </div>
                <span class="text-light mt-2" style={{ fontFamily: 'Inter', fontSize: "1rem", fontWeight: 500 }}>Loading...</span>
            </div>
        );
    else return null
}
